import { firebaseAuth } from '@app/firebase';
import { createUserWithEmailAndPassword } from '@firebase/auth';
import { signInWithPopup } from 'firebase/auth';
import { GoogleAuthProvider } from 'firebase/auth';
import API from '../api';

const provider = new GoogleAuthProvider();

// export const loginByAuth = async (email: string, password: string) => {
//   const token = 'I_AM_THE_TOKEN';
//   localStorage.setItem('token', token);
//   removeWindowClass('login-page');
//   removeWindowClass('hold-transition');
//   return token;
// };

// export const registerByAuth = async (email: string, password: string) => {
//   const token = 'I_AM_THE_TOKEN';
//   localStorage.setItem('token', token);
//   removeWindowClass('register-page');
//   removeWindowClass('hold-transition');
//   return token;
// };

export const registerWithEmail = async (email: string, password: string) => {
  try {
    const result = await createUserWithEmailAndPassword(
      firebaseAuth,
      email,
      password
    );
    return result;
  } catch (error) {
    throw error;
  }
};

export const loginWithEmail = async (email: string, password: string) => {
  try {
    // Replace Firebase auth login with a standard Node API call.
    // Assumptions:
    // - The backend exposes a POST /api/auth/login endpoint that accepts { email, password }
    // - The endpoint returns JSON: { token: string, user: { ... } }
    
    const res = await API.post("login", { email, password });

    const data = res.data; 
    // store token if provided
    if (data.token) {
      try {
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem('token', data.token);
      } catch (e) {
        // ignore storage errors
      }
    }

    // return an object with a `user` property so existing callers (Login.tsx) work
    return { user: data.user || null, token: data.token || null, raw: data };
  } catch (error) {
    throw error;
  }
};

export const signInByGoogle = async () => {
  try {
    return await signInWithPopup(firebaseAuth, provider);
  } catch (error) {
    throw error;
  }
};
